import { render, staticRenderFns } from "./Dependentes.vue?vue&type=template&id=f9b8d110&"
import script from "./Dependentes.vue?vue&type=script&lang=js&"
export * from "./Dependentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports